(ns common.schema.entities.esign-process-status)

(def status-options
  (->>
   [{:value :esign-process.status/not-started
     :label "Not started"}
    {:value   :esign-process.status/started
     :label "Started"}
    {:value   :esign-process.status/document-uploaded
     :label "Content uploaded"}
    {:value   :esign-process.status/sent
     :label "Sent"}
    {:value   :esign-process.status/signed
     :label "Signed"}
    {:value   :esign-process.status/canceled
     :label "Canceled"}
    {:value :esign-process.status/overdue
     :label "Overdue"}
    {:value :esign-process.status/declined
     :label "Declined"}
    {:value :esign-process.status/failed
     :label "Failed"}
    {:value :esign-process.status/unknown
     :label "Unknown"}]
   (mapv (fn [{:keys [value] :as opt}]
           (assoc opt :key value)))))

(def lookup
  (->> status-options
       (map (fn [opt]
              [(:key opt) (:label opt)]))
       (into {})))

(defn get-label
  [k]
  (get lookup k))
